/**
 * @fileoverview POST handler for the "/engagement/report_builder_2/:report_id/:app_group_id/cancel_query_builder_report" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2ReportIdCancelQueryBuilderReportCacheKeys } from "./constants";
import type { PostReportBuilder2CancelReportProps, PostReportBuilder2CancelReportResult } from "./types";

export const postReportBuilder2CancelReport = reactQueryMutationAdapter(
  engagementReportBuilder2ReportIdCancelQueryBuilderReportCacheKeys,
  (props: PostReportBuilder2CancelReportProps): Promise<PostReportBuilder2CancelReportResult> => {
    return fetch(
      `/engagement/report_builder_2/${props.reportId}/${props.appGroupId}/cancel`,
      "POST",
      props,
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
